module.exports = __webpack_public_path__ + "img/9.6.17da46cf.jpg";